import React, { useEffect, useState } from "react";
import dayjs from "dayjs";

import { s360ConfigService } from "../../Services/S360Config";

function MessageA97(props) {
  const [a97State, setA97State] = useState({
    checkedState: [],
    actionDone: false,
    values: [],
  });

  useEffect(() => {
    formatData(props?.entry?.text_data?.options);
  }, []);

  const formatData = (data) => {
    let initialArray = [];
    initialArray = new Array(data?.length).fill(false);
    setA97State(prev => ({ ...prev, checkedState: initialArray }));
  };

  const onChangeHandler = (position, e) => {
    const { checkedState } = a97State;
    // hardlimit to set the maximum select option
    let hardLimit = Math.floor(props?.entry?.text_data?.hardlimit);
    if (checkedState.filter((i) => i).length >= hardLimit && e.target.checked)
      return;
    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : item
    );
    setA97State(prev => ({ ...prev, checkedState: updatedCheckedState }));

    //get the option value and stored in a state
    if (e.target.checked) {
      setA97State(prev => ({ ...prev, values: [...a97State.values, e.target.value] }));
    } else {
      let index = a97State.values.indexOf(e.target.value.toString());
      a97State.values.splice(index, 1);
      setA97State(prev => ({ ...prev, values: a97State.values }));
    }

    console.log(a97State.values, a97State.checkedState);
  };

  const onSubmit = () => {
    console.log(JSON.stringify({ selectedOptions: a97State.values }));
    let dataToSend = JSON.stringify({ selectedOptions: a97State.values });
    props.actions.sendMessageWithCode(props.entry.keyword, {
      value: dataToSend,
      name: a97State.values.toString(),
    });
    var n = document.getElementsByClassName(
      "s360-message-box-custom-a15-received"
    );
    for (var i = 0; i < n.length; i++) {
      n[i].disabled = true;
      n[i].style.background = "none";
      // onMouseLeave({ "target": n[i]});
    }
    var a = document.getElementsByClassName("reason-checkbox");
    for (var j = 0; j < a.length; j++) {
      a[j].style.pointerEvents = "none";
      a[j].style.opacity = "0.5";
    }
  };

  const messageBoxSubmitStyle = () => {
    return {
      marginLeft: "15px",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "#0092ed",
      borderRadius: 20,
      color: "#0092ed",
      backgroundColor: "#fff",
      fontWeight: 500,
      ...s360ConfigService.config?.customDesign?.messageA97Submit
    };
  };

  const data = props?.entry?.text_data?.options;

  const { checkedState } = a97State;

  return (
    <div className="CheckBoxWithSubmit">
      <div className="CheckBoxContainer">
        {data.length === 0 ? (
          <p>No Options to display</p>
        ) : (
          data.map(({ name, value }, index) => (
            <div
              key={name}
              className={`oneCheckOption${checkedState[index] ? "-checked" : ""}`}
              style={{
                border: "1px solid #CCC",
                opacity:
                  !checkedState[index] &&
                    checkedState.filter((i) => i).length ===
                    parseInt(props?.entry?.text_data?.hardlimit)
                    ? 0.5
                    : 1,
                cursor:
                  !checkedState[index] &&
                    checkedState.filter((i) => i).length ===
                    parseInt(props?.entry?.text_data?.hardlimit)
                    ? "not-allowed"
                    : "default",
              }}
              id={value}
              onClick={() =>
                onChangeHandler(index, {
                  target: {
                    value: value,
                    checked: !checkedState[index],
                  },
                })
              }
            >
              <input
                className="reason-checkbox"
                type="checkbox"
                value={value}
                id={value}
                onChange={(e) => onChangeHandler(index, e)}
                disabled={
                  !checkedState[index] &&
                  checkedState.filter((i) => i).length ===
                  parseInt(props?.entry?.text_data?.hardlimit)
                }
                checked={checkedState[index]}
              ></input>
              <label className="checkbox-label">{name}</label>
            </div>
          ))
        )}
      </div>
      {props.isLastEntry && props.sentTimestamp && (
        <div>
          {dayjs.unix(props.sentTimestamp).format("DD MMM h:mm a")}
        </div>
      )}
      <div className="s360-message-cotainer-received">
        <button
          disabled={props.disabled}
          className="s360-message-box-custom-a15-received"
          onClick={
            a97State.values.length === 0
              ? console.log("not selected")
              : onSubmit
          }
          // onMouseEnter={onMouseEnterButton}
          // onMouseLeave={onMouseLeaveButton}
          style={messageBoxSubmitStyle()}
        >
          {props.entry.data
            ? JSON.parse(props.entry.data).buttonText
            : "Submit"}
        </button>
      </div>
    </div>
  );
}

export default MessageA97
